export function walletRows(source) {
  if (!source || typeof source !== 'object') return []
  const entries = Array.isArray(source)
    ? source.map(wallet => [walletKey(wallet), wallet])
    : Object.entries(source)
  return entries
    .map(([key, wallet]) => {
      const row = wallet && typeof wallet === 'object' ? wallet : {}
      const publicKey = walletKey(row) || String(key || '').trim()
      return { ...row, public_key: publicKey, publicKey }
    })
    .filter(wallet => walletKey(wallet))
}

export function sumWalletPnl(wallets, period) {
  return (wallets || []).reduce((total, wallet) => ({
    lamports: total.lamports + walletPnlValue(wallet, period),
    costLamports: total.costLamports + walletPnlCostValue(wallet, period),
  }), { lamports: 0, costLamports: 0 })
}

export function winrateText(pnl = {}, coins = []) {
  const wins = Number(pnl?.wins || 0)
  const losses = Number(pnl?.losses || 0)
  if (wins > 0 || losses > 0) return `${Math.round(Number(pnl?.winrate || 0))}%`

  let fallbackWins = 0
  let fallbackLosses = 0
  for (const coin of Array.isArray(coins) ? coins : Object.values(coins || {})) {
    const position = coin?.position
    if (!isClosedPosition(position)) continue
    const value = Number(position?.total_lamports ?? position?.totalLamports ?? 0)
    if (value > 0) fallbackWins++
    else if (value < 0) fallbackLosses++
  }
  const total = fallbackWins + fallbackLosses
  if (total === 0) return '--'
  return `${Math.round(fallbackWins * 100 / total)}%`
}

function walletKey(wallet) {
  return String(wallet?.public_key || wallet?.publicKey || wallet?.PublicKey || '').trim()
}

function walletPnlValue(wallet, period) {
  const w = wallet || {}
  if (period === 'day') return finiteNumber(w.pnl_day ?? w.pnlDay ?? w.PnLDay)
  if (period === 'week') return finiteNumber(w.pnl_week ?? w.pnlWeek ?? w.PnLWeek)
  if (period === 'month') return finiteNumber(w.pnl_month ?? w.pnlMonth ?? w.PnLMonth)
  return finiteNumber(w.pnl_lamports ?? w.pnlLamports ?? w.PnLLamports)
}

function walletPnlCostValue(wallet, period) {
  const w = wallet || {}
  if (period === 'day') return finiteNumber(w.pnl_day_cost ?? w.pnlDayCost ?? w.PnLDayCost)
  if (period === 'week') return finiteNumber(w.pnl_week_cost ?? w.pnlWeekCost ?? w.PnLWeekCost)
  if (period === 'month') return finiteNumber(w.pnl_month_cost ?? w.pnlMonthCost ?? w.PnLMonthCost)
  return finiteNumber(w.pnl_cost ?? w.pnlCost ?? w.PnLCost)
}

function finiteNumber(value) {
  const n = Number(value || 0)
  return Number.isFinite(n) ? n : 0
}

function positionStage(position) {
  return String(position?.stage || position?.Stage || '').trim().toUpperCase()
}

function isClosedPosition(position) {
  if (!position) return false
  if (positionStage(position) === 'FINAL') return true
  if (Number(position?.token_amount || position?.tokenAmount || 0) > 0) return false
  return Number(position?.spent_lamports || position?.spentLamports || 0) > 0 ||
    Number(position?.received_lamports || position?.receivedLamports || 0) > 0
}
